import { Component, Input, Output, EventEmitter } from '@angular/core';

export type AlertType = 'success' | 'error' | 'warning' | 'info';

@Component({
  selector: 'app-alert',
  standalone: false,
  templateUrl: './alert.component.html'
})
export class AlertComponent {
  @Input() type: AlertType = 'info';
  @Input() dismissible = false;
  @Input() visible = true;
  @Output() closed = new EventEmitter<void>();

  getAlertClass(): string {
    const base = 'p-4 mb-4 rounded-lg flex items-center transition-all duration-300';
    const variants: Record<AlertType, string> = {
      success: 'text-green-800 bg-green-50 border border-green-200',
      error: 'text-red-800 bg-red-50 border border-red-200',
      warning: 'text-orange-800 bg-orange-50 border border-orange-200',
      info: 'text-blue-800 bg-blue-50 border border-blue-200'
    };
    return `${base} ${variants[this.type]}`;
  }

  close() {
    this.visible = false;
    this.closed.emit();
  }
}
